import common from './colors.common';

import {
  greyA100,
  grey50,
  grey100,
  grey200,
  grey300,
  grey400,
  grey900,
  blue100,
  blue300,
  blue500,
  blue700,
  blue800,
  blue900,
  lightBlue100,
  lightBlue900,
  green50,
  green100,
  green600,
  green800,
  yellow100,
  yellow600,
  orange500,
  orange700,
  red100,
  red200,
  red300,
  red400,
  white,
  black,
} from './colors';

const colors = {};

colors.button = {
  primary: blue900,
  secondary: blue100,
  secondaryText: lightBlue900,
  secondaryStroke: blue500,
  alternate: blue500,
};

colors.heading = {
  // Todo: This is not a color
  regular:
    'font-size:0.75rem;font-weight:bold;line-height:15px;margin-bottom:7px;',
  color: grey900,
};

colors.overlay = {
  background: 'rgba(187,222,251,.7)',
};

colors.strip = {
  blue: lightBlue100,
  yellow: yellow100,
  green: green50,
  grey: greyA100,
  infoText: grey900,
  warning: yellow100,
  warningBorder: blue100,
  success: green100,
  successBorder: green600,
};

colors.list = {
  itemStroke: grey100,
};

colors.spinner = {
  bar: lightBlue900,
  barLightVariant: white,
};

colors.price = {
  lightBlue: blue800,
  blue: blue100,
  white: white,
  black: black,
};

colors.expando = {
  background: greyA100,
  collapsedStroke: grey100,
  expandedStroke: blue300,
  secondaryBackground: green100,
};

colors.buttonBar = {
  border: grey200,
  background: grey50,
};

colors.checkbox = {
  activeShadow: blue500,
};

colors.toggleSwitch = {
  borderColor: grey200,
  borderColorSelected: lightBlue900,
};

colors.modal = {
  background: blue100,
  wrapperBackground: lightBlue900,
  border: blue100,
  errorBackground: yellow100,
  errorColor: grey900,
};

colors.dismissible = {
  close: blue700,
  background: greyA100,
  titleBar: blue700,
};

colors.loading = {
  background: blue100,
  bar: blue800,
  border: grey100,
};

colors.seatMap = {
  planeLabel: grey200,
  tooltip: blue800,
  tooltipCloseText: blue800,
  travelerListAssignTitle: lightBlue100,
  travelerListRemove: blue800,
  travelerListDivider: grey100,
};

colors.datePicker = {
  border: grey100,
  dayList: grey900,
  tab: grey900,
  activeTab: blue100,
  disabled: grey300,
  highlight: lightBlue100,
  active: lightBlue900,
  currentDay: blue100,
  selected: green50,
};

colors.optionList = {
  text: lightBlue900,
  border: grey200,
  disabled: grey50,
};

colors.textFilter = {
  text: grey900,
  placeholder: grey400,
  border: grey200,
  shadow: grey50,
};

colors.quantitySelector = {
  default: blue500,
  disabled: grey200,
  input: grey400,
};

colors.sectionHeading = {
  background: blue800,
};

colors.labelledButton = {
  border: grey200,
  shadow: grey50,
  error: yellow100,
  errorText: grey900,
  disabled: grey50,
  color: grey300,
  validated: grey900,
};

colors.radioGroup = {
  border: grey200,
  shadow: grey50,
  error: yellow100,
  labelChecked: grey900,
  labelUnchecked: grey300,
  disabled: grey50,
  outline: common.focus,
};

colors.field = {
  border: grey200,
  shadow: grey50,
  text: grey300,
  input: grey900,
  disabledInput: grey300,
  disabled: grey50,
};

colors.flightDatePicker = {
  border: grey100,
  color: grey900,
  background: blue100,
};

colors.flightCard = {
  titleColor: grey400,
};

colors.tabs = {
  border: grey100,
  text: grey900,
  activeTab: blue100,
};

colors.input = {
  text: common.dark,
  background: common.light,
};

colors.card = {
  text: grey900,
  background: common.light,
  stroke: grey100,
  promo:
    'linear-gradient( 180deg,#cfd8dc 0%,rgba(236,239,241,0) 5%,rgba(176,190,197,0) 100% ),linear-gradient( 180deg,#fff 0%,#fff 35%,#b3e5fc 85%,#b3e5fc 100% )',
};

colors.seat = {
  available: blue100,
  availableBorder: blue300,
  active: green100,
  activeBorder: green600,
  activeArrow: blue800,
  unavailable: common.disabled,
  unavailableBorder: grey200,
  taken: green600,
  takenBorder: green800,
  legroom: blue800,
  legroomBorder: blue900,
  giant: yellow600,
  giantBorder: orange500,
  armrest: red100,
  armrestBorder: red200,
  legroomArmrest: red300,
  legroomArmrestBorder: red400,
  allegiantExtra: yellow600,
  allegiantExtraBorder: orange700,
};

colors.carousel = {
  background: common.dark,
  closeText: blue800,
  closeBorder: blue500,
};

colors.backButton = {
  text: grey900,
};

export default colors;
